/**
 * Stockage du jeton d'accès — EN MÉMOIRE, jamais persisté (E13, audit du
 * 2026-08-07).
 *
 * Avant : le jeton d'accès ET le refresh token vivaient dans `localStorage`,
 * donc lisibles par n'importe quel script. Une seule XSS emportait une session
 * de 30 jours, renouvelable indéfiniment et sans trace côté serveur.
 *
 * Maintenant :
 *   - le refresh token est un cookie `HttpOnly` posé par l'API — aucun code de
 *     cette application n'y a accès, et c'est le but : une XSS ne peut plus
 *     l'exfiltrer, seulement se servir de la session tant qu'elle s'exécute ;
 *   - le jeton d'accès (15 min) tient dans cette variable. Il disparaît à
 *     chaque rechargement de page, et `AuthProvider` en redemande un au montage
 *     via `/auth/refresh`, que le cookie authentifie.
 *
 * ⚠️ Ne JAMAIS remettre ces valeurs dans `localStorage`, `sessionStorage`, un
 * cookie lisible par script ou l'URL. C'est précisément ce que ce module existe
 * pour empêcher.
 */
let accessToken: string | null = null;

export const authTokens = {
  get access(): string | null {
    return accessToken;
  },
  set(access: string) {
    accessToken = access;
  },
  clear() {
    accessToken = null;
  },
};
